import { CoreTileConfig } from "../../pages/config";
import { TMDB_ENDPOINTS_STATIC } from "./apiHelper";

export enum CarouselType {
  POPULAR_MOVIES = "popular-movies",
  TOP_RATED_MOVIES = "top-rated-movies",
  UPCOMING_MOVIES = "upcoming-movies",
  POPULAR_TV_SHOWS = "popular-tv-shows",
  TOP_RATED_TV_SHOWS = "top-rated-tv-shows",
  ON_THE_AIR_TV_SHOWS = "on-the-air-tv-shows",
  TRENDING_MOVIES = "trending-movies",
  TRENDING_TV_SHOWS = "trending-tv-shows",
}

const carouselsArray: CarouselType[] = [
  CarouselType.TRENDING_MOVIES,
  CarouselType.TRENDING_TV_SHOWS,
  CarouselType.UPCOMING_MOVIES,
  CarouselType.TOP_RATED_MOVIES,
  CarouselType.POPULAR_MOVIES,
  CarouselType.POPULAR_TV_SHOWS,
  CarouselType.TOP_RATED_TV_SHOWS,
  CarouselType.ON_THE_AIR_TV_SHOWS,
];

const carouselsNameMap: Record<CarouselType, string> = {
  [CarouselType.POPULAR_MOVIES]: "Popular Movies",
  [CarouselType.TOP_RATED_MOVIES]: "Top Rated Movies",
  [CarouselType.UPCOMING_MOVIES]: "Upcoming Movies",
  [CarouselType.POPULAR_TV_SHOWS]: "Popular TV Shows",
  [CarouselType.TOP_RATED_TV_SHOWS]: "Top Rated TV Shows",
  [CarouselType.ON_THE_AIR_TV_SHOWS]: "On The Air TV Shows",
  [CarouselType.TRENDING_MOVIES]: "Trending Movies",
  [CarouselType.TRENDING_TV_SHOWS]: "Trending TV Shows",
};

export function getCarouselName(type: CarouselType) {
  return carouselsNameMap[type] || "Unknown Carousel";
}

function getRandomTileSize() {
  return Math.random() < 0.5
    ? CoreTileConfig.MID
    : Math.random() < 0.5
    ? CoreTileConfig.LARGE
    : Math.random() < 0.5
    ? CoreTileConfig.SMALL
    : CoreTileConfig.MID; // random tile size= SMALL, MID, LARGE
}
export function getAllCarouselTypes() {
  return carouselsArray.map((type) => ({
    type,
    apiTemplate: apiTemplateMap[type],
    name: carouselsNameMap[type],
    tileSize: getRandomTileSize(),
  }));
}

export const apiTemplateMap: Record<CarouselType, string> = {
  [CarouselType.POPULAR_MOVIES]: TMDB_ENDPOINTS_STATIC.MOVIES.POPULAR,
  [CarouselType.TOP_RATED_MOVIES]: TMDB_ENDPOINTS_STATIC.MOVIES.TOP_RATED,
  [CarouselType.TRENDING_MOVIES]: TMDB_ENDPOINTS_STATIC.TRENDING.MOVIE_WEEK,
  [CarouselType.UPCOMING_MOVIES]: TMDB_ENDPOINTS_STATIC.MOVIES.UPCOMING,
  [CarouselType.POPULAR_TV_SHOWS]: TMDB_ENDPOINTS_STATIC.TV_SHOWS.POPULAR,
  [CarouselType.TOP_RATED_TV_SHOWS]: TMDB_ENDPOINTS_STATIC.TV_SHOWS.TOP_RATED,
  [CarouselType.ON_THE_AIR_TV_SHOWS]: TMDB_ENDPOINTS_STATIC.TV_SHOWS.ON_THE_AIR,
  [CarouselType.TRENDING_TV_SHOWS]: TMDB_ENDPOINTS_STATIC.TRENDING.TV_WEEK,
};
